import { useMemo } from 'react';

const keyMapping = {
  date: 'relatedDateNormalized',
  client: 'customerNameNormalized',
  product: 'productNameNormalized',
  kind: 'productDescriptionNormalized',
  value: 'operationValueNormalized',
  balance: 'customerBalanceNormalized',
};

const parseDateString = (dateString) => {
  if (!dateString || dateString === '--') {
    return 0;
  }
  const [day, month, year] = dateString.split('/');
  return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
};

export const useFinancialSummaryOrdenation = (data, sortConfig) => {
  return useMemo(() => {
    if (!sortConfig?.key) {
      return data;
    }

    return [...data].sort((a, b) => {
      const mappedKey = keyMapping[sortConfig.key] ?? sortConfig.key;
      const valueA = a[mappedKey];
      const valueB = b[mappedKey];

      if (sortConfig.key === 'kind') {
        const numA = a.operationValueNormalized > 0 ? 1 : -1;
        const numB = b.operationValueNormalized > 0 ? 1 : -1;

        return sortConfig.direction === 'asc' ? numA - numB : numB - numA;
      }

      if (sortConfig.key === 'date') {
        const dateA = parseDateString(valueA);
        const dateB = parseDateString(valueB);
        return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
      }

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortConfig.direction === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return sortConfig.direction === 'asc'
        ? (valueA ?? 0) - (valueB ?? 0)
        : (valueB ?? 0) - (valueA ?? 0);
    });
  }, [data, sortConfig]);
};
